import { render, staticRenderFns } from "./Reporting.vue?vue&type=template&id=5f851e92&scoped=true"
import script from "./Reporting.vue?vue&type=script&lang=js"
export * from "./Reporting.vue?vue&type=script&lang=js"
import style0 from "./Reporting.vue?vue&type=style&index=0&id=5f851e92&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f851e92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f851e92')) {
      api.createRecord('5f851e92', component.options)
    } else {
      api.reload('5f851e92', component.options)
    }
    module.hot.accept("./Reporting.vue?vue&type=template&id=5f851e92&scoped=true", function () {
      api.rerender('5f851e92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/section/Reporting.vue"
export default component.exports